const REGISTRATION_ICON_TOOLTIP = `A matrícula deve ser igual à do
cadastro do eSocial. Se você
estiver efetuando o primeiro cadastro,
crie a matrícula por aqui. Ela será
utilizada sempre que você transmitir
eventos pelo eSocial.`;

const REGISTRATION_LABEL = 'Matrícula do eSocial';
const REGISTRATION_EXTRA_LABEL = 'Não são permitidos espaços no início ou no fim da matrícula.';

export {
  REGISTRATION_ICON_TOOLTIP,
  REGISTRATION_LABEL,
  REGISTRATION_EXTRA_LABEL,
};
